import React, { useRef, useEffect, useState } from 'react';
import '../styles/TermsModal.css'; // Your CSS file

const TermsPopup = ({ showPopup, handleClose, activeSection }) => {
  const termsRef = useRef(null);
  const privacyRef = useRef(null);
  const modalContentRef = useRef(null);

  const [activeTab, setActiveTab] = useState('');

  const scrollTo = (ref) => {
  if (ref?.current && modalContentRef?.current) {
    const offsetTop = ref.current.offsetTop;
    modalContentRef.current.scrollTo({
      top: offsetTop - 130, // Adjust this value as needed
      behavior: 'smooth'
    });
  }
};


  useEffect(() => {
    if (showPopup) {
        setActiveTab(activeSection)
        if (activeSection === 'terms') scrollTo(termsRef);
        else if (activeSection === 'privacy') scrollTo(privacyRef);
    }
  }, [showPopup, activeSection]);

//   const handleScroll = () => {
//     const scrollPos = modalContentRef.current.scrollTop;
//     const privacyOffset = privacyRef.current.offsetTop;
    
//     if (scrollPos + 100 >= privacyOffset) {
//       setActiveTab("privacy");
//     } else {
//       setActiveTab("terms");
//     }
//   };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (tab === 'terms') scrollTo(termsRef);
    else if (tab === 'privacy') scrollTo(privacyRef);
};

  if (!showPopup) return null;

  return (
    <div className="AF-popupOverlay">
      <div className="AF-popup">
        {/* Close Button */}
        <div className="AF-header">
          <button className="AF-closeBtnLeft" onClick={handleClose}>×</button>
        </div>

        {/* Tab Buttons */}
        <div style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
       <button
        className={`AF-submitBtn-term ${activeTab === "terms" ? "active" : ""}`}
        onClick={() => handleTabClick("terms")}
        >
        Terms & Conditions
        </button>
        <button
        className={`AF-submitBtn-term ${activeTab === "privacy" ? "active" : ""}`}
         onClick={() => handleTabClick("privacy")}
        >
        Privacy Policy
        </button>
        </div>


        {/* Modal Scrollable Content */}
        <div 
            ref={modalContentRef}
            className="AF-modal-content" 
            style={{ maxHeight: '400px', overflowY: 'auto', marginTop: '40px', paddingRight: '10px' }}
        >
          
          {/* Terms of Service Section */}
          <div ref={termsRef} className='terms-privacy-container'>
            <h2 className="form-label-join-term">Terms of Service</h2>
            <p><strong>Last updated:</strong> 15 September 2025</p>
            <p>Welcome to mybetbuilders.com, developed by Quotus Limited. By using the site, you agree to these terms. </p>

            <h3>1. Age restriction</h3>
            <p>This site provides betting-related information and is intended for audiences aged 18+ only. </p>

            <h3>2. Subscriptions </h3>
            <ul className='term-ul-li'>
              <li className='term-ul-li'>We offer Free and Pro subscription plans.</li>
              <li className='term-ul-li'>Pro subscriptions are available on a monthly (£4.99) or weekly (£1.99) basis. </li>
              <li className='term-ul-li'>Subscriptions include a 7-day free trial. After the trial, the subscription will auto-renew unless cancelled. </li>
              <li className='term-ul-li'>Payments are handled securely via PayPal. We do not store your payment details. </li>
            </ul>
            <h3>3. Cancellations & refunds</h3>
            <ul className='term-ul-li'>
              <li className='term-ul-li'>You can cancel anytime via your PayPal account.</li>
              <li className='term-ul-li'>Upon cancellation, Pro access will remain until the end of the billing cycle, then downgrade to Free. </li>
              <li className='term-ul-li'>Refunds are only available as required by UK consumer law (e.g. 14-day cooling-off period for digital subscriptions). </li>
            </ul>
            <h3>4. Country of residence </h3>
            <ul className='term-ul-li'>
              <li className='term-ul-li'>When subscribing, you must provide your country of residence.</li>
              <li className='term-ul-li'>We use this, along with your IP address and PayPal records, to comply with VAT/tax rules. </li>
            </ul>
            <h3>5. No betting advice </h3>
            <ul className='term-ul-li'>
              <li className='term-ul-li'>Our tools are for informational purposes only. </li>
              <li className='term-ul-li'>We are not a betting operator and do not place bets on your behalf.</li>
              <li className='term-ul-li'>You are solely responsible for any betting decisions made using this site.</li>
            </ul>

            <h3>6. Intellectual property </h3>
            <p>All site content, tools, and designs belong to Quotus Limited and must not be copied, resold, or repurposed without written permission.</p>

            <h3>7. Limitation of liability </h3>
            <p>We are not liable for any direct or indirect loss arising from your use of the site. Use is at your own risk.</p>

            <h3>8. Termination</h3>
            <p>We may suspend or remove access if you breach these terms.</p>
            <h3>9. Changes to Terms </h3>
            <p>We may update these terms at any time. Continued use of the site means you accept the updated terms.</p>
            <h3>10. Governing Law </h3>
            <p>These terms are governed by the laws of England and Wales, and any disputes will be resolved in the UK courts. </p>
          </div>

          <hr />

          {/* Privacy Policy Section */}
          <div className='terms-privacy-container' ref={privacyRef} style={{ marginTop: '40px' }}>
            <h2 className="form-label-join-term">We value Your privacy</h2>
            <p><strong>Last updated:</strong> 15 September 2025</p>
            <p>This Privacy Policy explains how we collect, use, and protect your personal data when you use <strong>mybetbuilders.com</strong>.</p>

            <h3>1. Who we are</h3>
            <p>We are Quotus Limited, the company behind mybetbuilders.com. For any data queries, contact us at: <a href="mailto:contact@mybetbuilders.com">contact@mybetbuilders.com</a></p>

            <h3>2. What data we collect</h3>
            <p>We may collect: </p>
            <ul className='term-ul-li'>
              <li className='term-ul-li'>Email address (when you sign up or subscribe) </li>
              <li className='term-ul-li'>Login details (email + password, encrypted) </li>
              <li className='term-ul-li'>Subscription information (plan type, start/renewal dates)</li>
              <li className='term-ul-li'>Payment details (processed securely by PayPal – we never store card details)</li>
              <li className='term-ul-li'>Country of residence (for legal/tax compliance)</li>
              <li className='term-ul-li'>IP address (for fraud prevention and VAT rules)</li>
              <li className='term-ul-li'>Usage data (e.g. page views, button clicks)</li>
  
            </ul>

            <h3>3. Why we collect your data</h3>
            <p>We collect your data to:</p>
            <ul>
              <li>Provide and improve our services</li>
              <li>Manage subscriptions and billing</li>
              <li>Ensure compliance with tax laws</li>
              <li>Contact you with service updates or product offers (if opted in)</li>
              <li>Understand how users interact with the platform</li>
            </ul>
            <p><strong>Our legal basis for processing your data is:</strong></p>
            <ul>
              <li>Contract (providing your subscription)</li>
              <li>Consent (marketing emails)</li>
              <li>Legitimate interest (improving services, preventing fraud)</li>
              <li>Legal obligation (tax compliance)</li>
            </ul>

            <h3>4. Sharing your data </h3>
            {/* <p>You have the right to:</p> */}
            <ul>
              <li>Payments are processed by PayPal. </li>
              <li>We do not sell or share your data with third parties for marketing.</li>
              <li>We may share anonymised usage data with analytics providers. </li>
            </ul>

            <h3>5. Your rights</h3>
            <p>You have the right to: </p>
            <ul>
              <li>Access your personal data</li>
              <li>Request correction or deletion </li>
              <li>Withdraw consent at any time </li>
              <li>Lodge a complaint with the UK ICO </li>
            </ul>
            <p>To make a request, email: <a href="mailto:contact@mybetbuilders.com">contact@mybetbuilders.com</a></p>
            
            <h3>6. Data security & retention</h3>
            <ul>
              <li>Data is stored securely in the UK/EU. </li>
              <li>Subscription and billing records are retained as required by tax law (typically 6 years).</li>
              <li>Other personal data is retained only as long as necessary.</li>
            </ul>

            <h3>6. Cookies</h3>
            <p>We use basic cookies to:</p>
            <ul>
              <li>Understand how users interact with the site (via analytics)</li>
              <li>Improve functionality and performance</li>
            </ul>
            <p>You can control cookies in your browser settings. We will display a cookie banner to inform you.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPopup;
